<script>

export default {
    props: [
       // 'openModal'
    ],
    data: () =>{
        return {
            phone: true,
        };
    },
    beforeMount: function(){
        if(window.innerWidth >= 768) {
            this.phone = false;
        }
    },
    mounted: function() {
        if (this.phone) {
            this.setHeight();
            window.addEventListener('resize', this.setHeight, false);
        }
    },
    beforeDestroy: function() {
        if (this.phone) {
            window.removeEventListener('resize', this.setHeight, false);
        }
    },
    methods: {
        setHeight: function() {
            const headerHeight = $('.main-nav').height();
            if (this.phone && window.matchMedia("(orientation: portrait)").matches) {
                $('#app').css({
                    'min-height': `${window.innerHeight - headerHeight}`
                });
                $('.homepage-carousel').css({
                    'height': `${window.innerHeight - headerHeight}`
                });
                $('.slick-slide').css({
                    'height': `${window.innerHeight - headerHeight}`
                });
            }
        }
    }
};

</script>



// WEBPACK FOOTER //
// resources/components/apps/homepage-carousel.vue